import * as Select from '@studio/design-system/select';
import { useLatestFn, useLazyRef } from '@studio/react-utils/hooks';
import { toEnumValues } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import type { Props } from './types.js';
import { Category, Categories as M_Categories, toCategory } from '#~/hot-keys/index.js';

/** `<Categories>` component. */
export const Categories = ({ category, size, ...props }: Props): ReactElement => {
  const handleValueChange = useLatestFn((nextValue: string) => {
    const nextCategory = toCategory(nextValue);

    if (nextCategory && nextCategory !== category.value) {
      category(nextCategory);
    }
  });

  return (
    <Select.Root onValueChange={handleValueChange} size={size} value={category.value}>
      <Select.Trigger {...props}>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        {
          useLazyRef(() =>
            toEnumValues(Category)
              .sort((a, b) => M_Categories[a].order - M_Categories[b].order)
              .map((µ) => (
                <Select.Item key={µ} value={µ}>
                  {M_Categories[µ].label}
                </Select.Item>
              ))
          ).current
        }
      </Select.Content>
    </Select.Root>
  );
};
